<a href="https://www.youthhostel.ch/" target="_blank" rel="noopener noreferrer">
  <div class="header__logo" >
    <img [src]="imageSrc$ | async" alt="logo">
  </div>
</a>
<nav class="header__menu">
  <ul>
    <li class="header__menu__item" (click)="onHomeClick();$event.preventDefault();$event.stopPropagation()" >
      <span class="header__icon header__icon--home" role="img" aria-label="home"></span>
    </li>

    @if (authorized$ | async) {
      <li class="header__menu__item" (click)="logout();$event.preventDefault();$event.stopPropagation()" cdkOverlayOrigin #logoutDropdownTrigger="cdkOverlayOrigin">
        <span class="header__icon header__icon--logout" role="img" aria-label="sign out"></span>
      </li>
    } @else {
      <li class="header__menu__item" (click)="login()">
        <span class="header__icon header__icon--login" role="img" aria-label="sign in"></span>
      </li>
    }

    <li class="header__menu__item" (click)="switchLangDropdown();$event.preventDefault();$event.stopPropagation()" cdkOverlayOrigin #langDropdownTrigger="cdkOverlayOrigin">
      <div class="lang-item">
        <span>{{ language$ | async }}</span>
      </div>
    </li>

    <li class="header__menu__item" cdkOverlayOrigin #logoutDropdownTrigger="cdkOverlayOrigin">
      <checkout-shopping-cart
        class="web-component icon shopping-cart"
        emitEvent="dsBookingEngine_openShoppingCart"
        countmode="items">
          <div slot="checkoutShoppingCart" class="cart-slot" (click)="onShoppingCart()">
            <i class="circle" [ngClass]="{'hidden': !(orderItemCount$ | async) || (orderItemCount$ | async) == 0}"><span></span></i>
          </div>
      </checkout-shopping-cart>
    </li>

    <!-- @if (!(isBookingPage$ | async)) {
    <li class="header__menu__item">
      <a [routerLink]="'/'" (click)="onHomeClick()">
        <i class="fa-kit fa-home-uh"></i>
        <span>{{'home' | translate}}</span>
      </a>
    </li>
    } -->
  </ul>
</nav>


<ng-template cdkConnectedOverlay  [cdkConnectedOverlayOrigin]="langDropdownTrigger" [cdkConnectedOverlayOpen]="showLangDropdown">
  <div class="bg-container">
    <div class="drop-list">
      @for (lang of filteredLanguages$ | async; track lang) {
        <div class="lang-item">
          <span (click)="selectLang(lang)">{{ lang }}</span>
        </div>
      }
    </div>
  </div>
</ng-template>
